export const appsApiLimitsCompanyRateLimitDatatable = "/apps/api_limits/company_rate_limit_datatable";
